/**
 * Created by kz on 28.06.17.
 */
import * as actions from './actions'
import * as getters from './getters'
import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    tenders: [],
    stageParticipations: [],
    current: {
      _id: 0,
      name: null,
      description: null,
      conditions: {
        name: null,
        path: null
      },
      holder: {
        name: null
      },
      stages: [{
        id: 1,
        enabled: false,
        scheduledLaunch: new Date(),
        scheduledSuspend: new Date()
      }],
      questionnaire: {}
    }
  },
  mutations: {
    receive (state, tenders) {
      state.tenders = tenders
    },
    current (state, tender) {
      _.assignIn(state.current, tender)
    },
    stageParticipations (state, participations) {
      state.stageParticipations = participations
    }
  },
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/tender/index.js